import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  TextField,
  Grid,
  Card,
  CardContent,
  Typography,
  useMediaQuery, // <--- 1. IMPORTAR useMediaQuery
} from "@mui/material";
import { useTheme } from '@mui/material/styles'; // <--- 2. IMPORTAR useTheme
import { DatePicker } from "antd";
import { ConfigProvider } from "antd";

import './DatePickerStyle.css'

export default function RentDressServiceDialog({ open, onClose, onSelect, dressList, dressSelectionService, dressReservations, newDressReservation }) {
  const [search, setSearch] = useState("");
  const [selectedDress, setSelectedDress] = useState(null);
  const [dress, setDress] = useState(null);
  const [dateRange, setDateRange] = useState(null);
  const [datePickerStatus, setDatePickerStatus] = useState('error');
  const [dresses, setDresses] = useState([...dressList]);

  // --- 3. APLICAR HOOKS PARA RESPONSIVIDAD ---
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm')); // 'sm' es un buen breakpoint para móviles

  // Function to generate a range of numbers from start to end
  const range = (start, end) => {
    const result = [];
    for (let i = start; i < end; i++) {
      result.push(i);
    }
    return result;
  }

  // Function to disable range times in the date picker
  const disabledRangeTime = (_, type) => {
    if (type === 'start') {
      return {
        disabledHours: () => range(0, 24).filter((hour) => hour < 8 || hour > 18)
      };
    } else {
      return {
        disabledHours: () => range(0, 24).filter((hour) => hour < 8 || hour > 20)
      };

    }
  }

  const filteredDresses = dresses.filter((dress) =>
    dress.dressName.toLowerCase().includes(search.toLowerCase()) ||
    (dress.code && dress.code.toLowerCase().includes(search.toLowerCase()))
  );

  const handleSelect = (dress) => {
    setSelectedDress(dress.dressID);
    setDress(dress);
  };

  const handleRangeDate = (dates) => {
    if (dates && dates.length > 0) {
      const rangeDates = dates.map((date) => date.format('YYYY-MM-DD HH:mm:ss'));
      const range = {
        eventDateStart: rangeDates[0],
        eventDateEnd: rangeDates[1],
      }
      return setDateRange(range);
    }
    return setDateRange(null);
  };

  const filterAvailableDresses = (dressList) => {
    const firstFilter = dressList.filter(dress => {
      return !dressReservations.some(dressReservation => {
        const reservationStart = new Date(dressReservation.eventDateStart);
        const reservationEnd = new Date(dressReservation.eventDateEnd);
        const eventStart = new Date(dateRange.eventDateStart);
        const eventEnd = new Date(dateRange.eventDateEnd);

        const isDressReserved = dressReservation.dressID === dress.dressID;
        const isDress = dress.dressID > 3;

        const hasDateConflict = (eventStart >= reservationStart && eventStart <= reservationEnd) ||
          (eventEnd >= reservationStart && eventEnd <= reservationEnd) ||
          (eventStart <= reservationStart && eventEnd >= reservationEnd);

        return isDressReserved && hasDateConflict || !isDress;
      });
    });
    if (newDressReservation && newDressReservation.length > 0) {
      const secondFilter = firstFilter.filter(dress => {
        return !newDressReservation.some(dressReservation => {
          const reservationStart = new Date(dressReservation.eventDateStart);
          const reservationEnd = new Date(dressReservation.eventDateEnd);
          const eventStart = new Date(dateRange.eventDateStart);
          const eventEnd = new Date(dateRange.eventDateEnd);

          const isDressReserved = dressReservation.dressID === dress.dressID;
          const isDress = dress.dressID > 3;

          const hasDateConflict = (eventStart >= reservationStart && eventStart <= reservationEnd) ||
            (eventEnd >= reservationStart && eventEnd <= reservationEnd) ||
            (eventStart <= reservationStart && eventEnd >= reservationEnd);

          return isDressReserved && hasDateConflict || !isDress;
        });
      });
      return secondFilter;
    }
    return firstFilter;
  };

  const handleConfirm = () => {
    onSelect(dress, dressSelectionService, dateRange);
    onClose();
  };

  const handleCancel = () => {
    onClose();
    setDateRange(null);
  };

  useEffect(() => {
    if (dateRange) {
      if (dateRange.eventDateStart && dateRange.eventDateEnd) {
        setDatePickerStatus('success');
      } else {
        setDatePickerStatus('error');
      }
    }
    else {
      setDatePickerStatus('error');
    }
  }, [dateRange]);

  useEffect(() => {
    if (dateRange) {
      setDresses(filterAvailableDresses(dressList));
    } else {
      setDresses([...dressList]); // Reset dress list if date range is cleared
    }
  }, [dateRange]);

  useEffect(() => {
    if (open) {
      // Reset state when dialog opens
      setSearch("");
      setSelectedDress(null);
      setDress(null);
      setDateRange(null);
    }
  }, [open]);

  return (
    // --- 4. AÑADIR LA PROPIEDAD fullScreen ---
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="md"
      fullScreen={isMobile} // <-- ESTA LÍNEA RESUELVE EL PROBLEMA
      sx={{ zIndex: 1500, alignItems: 'flex-start !important' }} // Aumentar z-index por si acaso
    >
      <DialogTitle>Selector de vestidos</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Selecciona la fecha del alquiler
        </DialogContentText>
        <ConfigProvider theme={{
          components: {
            DatePicker: {
              zIndexPopup: 2000,
            },
          },
        }}>
          <DatePicker.RangePicker
            showTime
            disabledTime={disabledRangeTime}
            onChange={(dates) => handleRangeDate(dates)}
            status={datePickerStatus}
            style={{
              width: '100%',
              height: '40px',
              marginBottom: '1rem',
              right: 0,
            }}
            // Prop opcional que puede ayudar a renderizar el popup en el body, evitando recortes.
            getPopupContainer={() => document.body}
          />
        </ConfigProvider>
        {
          dateRange && (
            <Grid container spacing={2} sx={{ marginTop: '0.5rem' }}>
              <DialogContentText sx={{ marginLeft: '1rem' }}>
                Seleccione el vestido a alquilar
              </DialogContentText>
              <Grid item xs={12}>
                <TextField
                  label="Buscar vestido"
                  variant="outlined"
                  fullWidth
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                />
              </Grid>
              {
                filteredDresses.map((dress) => (
                  <Grid item xs={12} sm={6} md={4} key={dress.dressID}>
                    <Card
                      onClick={() => handleSelect(dress)}
                      sx={{
                        cursor: "pointer",
                        backgroundColor: selectedDress === dress.dressID ? "rgba(0, 0, 0, 0.04)" : "white",
                      }}
                    >
                      <CardContent sx={{ height: "90px" }}>
                        <Typography variant="h6">{dress.dressName}</Typography>
                        <Typography variant="body2" color="textSecondary">
                          Código: {dress.code}
                        </Typography>
                      </CardContent>
                    </Card>
                  </Grid>
                ))
              }
              {filteredDresses.length === 0 && (
                <Grid item xs={12}>
                  <Typography align="center" color="textSecondary" sx={{ mt: 2 }}>
                    No hay vestidos disponibles para las fechas seleccionadas.
                  </Typography>
                </Grid>
              )}
            </Grid>
          )
        }
      </DialogContent>
      <DialogActions>
        <Button onClick={handleCancel} color="error" variant="contained">
          Cancelar
        </Button>
        <Button
          onClick={handleConfirm}
          color="success"
          variant="contained"
          disabled={!selectedDress || !dateRange}
        >
          Confirmar
        </Button>
      </DialogActions>
    </Dialog>
  );
}